import {apiBase} from 'api/base.js';

class MasterCowLabelAPI {
  available(farmId) {
    return apiBase.get(`/admin/master_cow_label/available?farm_id=${farmId}`);
  }
}

export const masterCowLabelAPI = new MasterCowLabelAPI();
